import React from "react";
import "./Inside_The_Matress.css";
import Common_Title from "../../common_components/common_title/Common_Title";

const features = [
  {
    label: "3D Ventilated Fabric",
    icon: "/assets/images/hospitality/fabric.png",
  },
  { label: "Polyfil", icon: "/assets/images/hospitality/polyfill.png" },
  {
    label: "Soft Foam (3/4/10)",
    icon: "/assets/images/hospitality/soft foam.png",
  },
  {
    label: "Comfort Foam",
    icon: "/assets/images/hospitality/comfort_foam.png",
  },
  { label: "Non-Woven", icon: "/assets/images/hospitality/non-wooven.png" },
  {
    label: "Thermobond Felt (7 / 9)",
    icon: "/assets/images/hospitality/thermobond.png",
  },
  {
    label: "Pocket Springs",
    icon: "/assets/images/hospitality/pocket-spring.png",
  },
  {
    label: "Anti-Skid Fabric",
    icon: "/assets/images/hospitality/anti skid.png",
  },
];

function Inside_The_Matress() {
  return (
    <div className="mattress luxery-section">
      <div className="container">
        <div className="title_with_line">
          <Common_Title title="Inside the Mattress" />
        </div>
      </div>

      <div className="container">
        <div className="mattress-container row luxery-section">
          <div className="mattress-image col-lg-6 col-md-6">
            <img
              src="/assets/images/hospitality/matress.png"
              alt="Mattress with layers"
              className="mattress-main-img"
            />
          </div>

          <div className="mattress-features col-lg-4 col-md-6 col-sm-8 col-4">
            {features.map((feature, index) => (
              <div key={index} className="feature-item">
                <span className="feature-arrow" />
                <div className="feature-content">
                  <img src={feature.icon} alt="" className="feature-icon" />
                  <span className="feature-label">{feature.label}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Inside_The_Matress;
